import React, { PropTypes } from "react";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";

const FollowUpsNav = (props) => {
  return (
    <div className="sub-nav">
      <ul>
        <li>
          <Link to="/dashboard/follow-ups/list" activeClassName="active">
            <FormattedMessage
              id="followUps.pages.list"
              values={{ followUpsCount: props.followUpsCount }}
            />
          </Link>
        </li>
        <li>
          <Link to="/dashboard/follow-ups/messages" activeClassName="active">
            <FormattedMessage
              id="followUps.pages.messages"
              values={{ messagesCount: props.messagesCount }}
            />
          </Link>
        </li>
      </ul>
    </div>
  );
};

FollowUpsNav.propTypes = {
  followUpsCount: PropTypes.number,
  messagesCount: PropTypes.number,
};

export default FollowUpsNav;



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/FollowUpsNav.js